<mat-tab-group #tabGroup>
  <mat-tab>
    <mat-label *matTabLabel>
      About
    </mat-label>

    <br/>
    <rsValidForm #form="rsValidForm" [rsValidOnceInteracted]="true">
      <div class="inputs">

        <div class="field">
          <div class="label">Date</div>
          <div class="input">
            <mat-form-field appearance="fill">
              <mat-label>Choose a date</mat-label>
              <input matInput [matDatepicker]="picker" [ngModel]="meeting.date | amFromUnix" (ngModelChange)="setDate($event)" rsValid="required">
              <mat-datepicker-toggle matSuffix [for]="picker">
                <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
              </mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
          </div>
        </div>

        <div class="field">
          <div class="label">Topic</div>
          <div class="input">
            <mat-form-field [floatLabel]="'always'" appearance="fill">
              <mat-label>Topic</mat-label>
              <input matInput [(ngModel)]="meeting.topic" placeholder="Topic" rsValid="meeting_topic" />
            </mat-form-field>
          </div>
        </div>

        <div class="field">
          <div class="label">Location (Town)</div>
          <div class="input">
            <mat-form-field [floatLabel]="'always'" appearance="fill">
              <mat-label>Location (Town)</mat-label>
              <input matInput [(ngModel)]="meeting.locationTown" placeholder="Town" rsValid="event_town" />
            </mat-form-field>
          </div>
        </div>

        <div class="field">
          <div class="label">Location (LGA)</div>
          <div class="input">
            <mat-form-field [floatLabel]="'always'" appearance="fill">
              <mat-label>Location (LGA)</mat-label>

              <mat-select [(ngModel)]="meeting.locationLga" rsValid="required">
                <mat-select-trigger>
                  {{ (meeting.locationLga | resolveLga).name }}
                </mat-select-trigger>
                <mat-option [value]="lga.id" *ngFor="let lga of (dataService.localDefinitions | async)?.lga">
                  {{lga.name}} ({{lga.type}})
                </mat-option>
              </mat-select>

            </mat-form-field>
          </div>
        </div>

        <div class="field">
          <div class="label">Notes</div>
          <div class="input full">
            <mat-form-field [floatLabel]="'always'" appearance="fill">
              <mat-label>Notes</mat-label>
              <input matInput [(ngModel)]="meeting.notes" placeholder="Notes" />
            </mat-form-field>
          </div>
        </div>
      </div>
    </rsValidForm>
  </mat-tab>
  <mat-tab>
    <mat-label *matTabLabel>
      Attendees
    </mat-label>

    <mat-card appearance="outlined" class="mat-elevation-z2 p-2 m-2">
      <mat-card-header>
        <mat-card-title><h2>Registered</h2></mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <mat-list class="odd-even-list">
          <mat-list-item *ngFor="let prop of selectedProperties" class="mr-0 ml-0">
            <div class="row">
              <span class="col-8 ellipsis" style="line-height: 28px; font-size: medium">
                <span class="font-italic" [matTooltip]="prop.id">{{ prop.id | formatPropertyId }}:</span> {{ prop.name ? prop.name + ', ' : '' }}{{ prop.address }}
              </span>
              <span class="col-4 text-right">

                <button mat-icon-button color="primary" (click)="updatePropertyAttendee(prop, -1)" ><mat-icon>remove_circle</mat-icon></button>
                {{ propertyAttendees[prop.id] }}
                <button mat-icon-button color="primary" (click)="updatePropertyAttendee(prop, 1)" ><mat-icon>add_circle</mat-icon></button>
                &nbsp;&nbsp;
                <button mat-icon-button color="warn" (click)="selectProperty(prop)" ><mat-icon>clear</mat-icon></button>
              </span>
            </div>
          </mat-list-item>
        </mat-list>
      </mat-card-content>
    </mat-card>

    <br/>
    <mat-card appearance="outlined" class="mat-elevation-z2 p-2 m-2">
      <mat-card-header>
        <mat-card-title><h2>Register property</h2></mat-card-title>
      </mat-card-header>
      <mat-card-content>

        <mat-tab-group selectedIndex="0">
          <mat-tab>
            <mat-label *matTabLabel><mat-icon>history</mat-icon> Recent</mat-label>
            <div class="mt-1 p-2">
              <app-grower-recent [class]="'flex-wrap'" [highlighted]="selectedProperties" (selected)="selectProperty($event)"></app-grower-recent>
            </div>
          </mat-tab>
          <mat-tab>
            <mat-label *matTabLabel><mat-icon>search</mat-icon> Search Hort360</mat-label>
            <div class="mt-1 p-2">
              <app-grower-search [highlighted]="selectedProperties" [savedSearch]="false" (selected)="selectProperty($event)"></app-grower-search>
            </div>
          </mat-tab>
          <mat-tab>
            <mat-label *matTabLabel><mat-icon>add_circle_outline</mat-icon> Search Others</mat-label>

            <div class="mt-1 p-2 d-flex flex-nowrap">
              <app-grower-others [highlighted]="selectedProperties" [savedSearch]="false" (selected)="selectProperty($event)"></app-grower-others>
            </div>

          </mat-tab>
        </mat-tab-group>

      </mat-card-content>
    </mat-card>

  </mat-tab>
</mat-tab-group>

<br/>
<ng-template #actionButtons>
  <button mat-button (click)="close()">
    Cancel
  </button>

  <button color="primary" mat-button (click)="nextTab()" *ngIf="tabGroup.selectedIndex === 0">
    Next
  </button>

  <button color="primary" mat-button (click)="saveMeeting()" *ngIf="tabGroup.selectedIndex !== 0">
    <mat-icon>save</mat-icon> Save
  </button>
</ng-template>


